module.exports = __webpack_public_path__ + "static/media/emptyData.264bbfed.svg";